const formatApiValuesFromCheckboxList = (allOptions = [], selectedOptions) => {
  let obj = {};

  allOptions.map(option => {
    obj[option.value] =
      selectedOptions.indexOf(option.value) > -1 ? true : false;
    return option;
  });

  return obj;
};

export { formatApiValuesFromCheckboxList };
